import { FC } from "react";

import classes from "./PopoverHeader.module.css";
import { TextEnum } from "../TextStyles";
interface IPopoverHeaderProp {
  title?: string;
  borderBottom?: boolean;
  textSize?: TextEnum;
}
const PopoverHeader: FC<IPopoverHeaderProp> = ({
  title,
  borderBottom = true,
  textSize = TextEnum.h4,
}) => {
  return (
    <div className={`${classes["title"]} ${textSize} ${borderBottom ? classes["title-border"] : ""}`}>
      {title}
    </div>
  );
};

export default PopoverHeader;
